var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.75C5.16875 1.75 1.25 5.66875 1.25 10.5C1.25 15.3313 5.16875 19.25 10 19.25C14.8313 19.25 18.75 15.3313 18.75 10.5C18.75 5.66875 14.8313 1.75 10 1.75ZM10 18C5.8625 18 2.5 14.6375 2.5 10.5C2.5 6.3625 5.8625 3 10 3C14.1375 3 17.5 6.36875 17.5 10.5C17.5 14.6313 14.1375 18 10 18ZM7.85 11.3625C7.00625 10.8937 5.9125 10.4688 4.5125 10.2312C4.4125 10.4625 4.425 10.4312 4.33125 10.6562C4.96875 11.15 5.86875 11.975 6.60625 13.1562C6.925 13.6687 7.225 14.2812 7.4875 14.9562C8.25625 14.95 8.28125 14.9625 9.05 14.9562C9.3375 14.1875 9.6375 13.4562 9.88125 12.9812C10.9625 10.8312 13.0063 8.325 14.8625 6.64375L14.6187 6.24375C10.9187 7.61875 9.0875 9.85 7.85 11.3625Z",
    fill: "#328714"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/Checkmark.9d5cc558820c34d9f1aec019b6e8adba.svg";
export { ForwardRef as ReactComponent };